/* global StackDiscounts */

/* global Swiper */

/* global cartGiftsEnabled */

/* global cartGiftLimits */

/* global eggoABC */

import {hideDomElement} from "../helpers";

export class EggoCartDiscountLogic {
    constructor(EggoCart) {
        this.eggoCart = EggoCart;
        this.cart = StackDiscounts.cart;
        this.cartPrice = this.cart.total_price;
        this.cartIndex = this.createCartIndex();
        this.giftDomElements = this.eggoCart.querySelectorAll(".cart-drawer__inner-real .cart-drawer__gift");
        this.abcDomElements = this.eggoCart.querySelectorAll(".cart-drawer__inner-real .cart-drawer__upsell-item");
        this.giftIds = this.getGiftIds();
        this.abcIds = this.getAbcIds();
        const upsellSectionIsHidden = this.runUpsellLogic();
        const giftSectionIsHidden = this.runGiftLogic();
        if (upsellSectionIsHidden && (giftSectionIsHidden || !cartGiftsEnabled)) {
            this.hideBothSections();
        } else {
            new Swiper('.cart-drawer__inner-real .cart-drawer-product-card__list', {
                loop: false,
                spaceBetween: 16
            });
        }
    }


    createCartIndex() {
        return this.cart.items.reduce((cartIndex, cartItem) => {
            cartIndex[cartItem.product_id] = cartItem;
            return cartIndex;
        }, {})
    }

    getGiftIds() {
        if (!this.giftDomElements) return [];
        return [...this.giftDomElements].reduce((giftList, giftDomElement) => {
            giftList.push(giftDomElement.dataset.productId);
            return giftList;
        }, [])
    }

    getAbcIds() {
        if (!this.abcDomElements) return [];
        return [...this.abcDomElements].reduce((abcList, abcDomElement) => {
            abcList.push(abcDomElement.dataset.productId);
            return abcList;
        }, [])
    }

    runUpsellLogic() {
        let hideUpsellSection = true;

        /* Those are all of the discounts that can be visible on the page */
        let availableABCDiscounts = eggoABCRegistered;
        let possibleABCDiscounts = new Set(eggoABC.reduce((all, upsell) => {
            if (this.cartIndex?.[upsell.product]) {
                return [...all, ...upsell.associations];
            }
            return all;
        }, []));

        let discountsAlreadyInTheCart = new Set(eggoABC.reduce((all, upsell) => {
            upsell.associations.forEach((association) => {
                if (this.cartIndex?.[association]) {
                    all.push(association.toString());
                }
            });
            return all;
        }, []));
        const discountsNotInTheCart = {};
        availableABCDiscounts.forEach((discountId) => {
                const discountDomElement = document.querySelector(`.cart-drawer__inner-real .cart-drawer__upsell-item[data-product-id="${discountId}"]`);
                if (possibleABCDiscounts.has(discountId) && !discountsAlreadyInTheCart.has(discountId)) {
                    if (discountDomElement) hideUpsellSection = false;
                    discountsNotInTheCart[discountId] = 0;
                    return;
                }
                hideDomElement(discountDomElement);
            }
        )

        this.runAbcOrderDiscount(discountsNotInTheCart);
        if(hideUpsellSection) this.hideUpsellSection();
        return hideUpsellSection;
    }

    runAbcOrderDiscount(discountsInTheCart){
        try {
            this.cart.items.forEach((item) => {
                const productId = item.product_id;
                const abcProduct = this.findProductInEggoAbc(productId);
                if(!abcProduct) return;
                const associations = abcProduct.associations;
                associations.forEach((associationId, index) => {
                    if(discountsInTheCart?.[associationId] !== null){
                        discountsInTheCart[associationId] += index;
                    }
                })
            });
        }
        catch(error){
            // No items in the cart. No damage here.
        }
        const allElements = document.querySelectorAll(`.cart-drawer__inner-real .cart-drawer__upsell-item`)

        allElements.forEach((element) => {
            element.style.order = 100000;
        })

        Object.entries(discountsInTheCart).forEach(([discountId, order]) => {
            const productElement = document.querySelector(`.cart-drawer__inner-real .cart-drawer__upsell-item[data-product-id="${discountId}"]`)
            if(!productElement) return;
            productElement.style.order = order;
        } );
    }

    findProductInEggoAbc(productId){
        for(let product of eggoABC){
            if(product.product == productId){
                return product;
            }
        }
        return null;
    }

    runGiftLogic() {
        const giftInTheCart = this.giftIds.find(giftId => this.cartIndex?.[giftId]);
        if (giftInTheCart) {
            this.hideGiftSection();
            return true;
        }

        const giftRule = this.generateGiftRule();
        if (giftRule.locked === null && giftRule.unlocked === null) {
            this.hideGiftSection();
            return true;
        }
        if (giftRule.locked) this.showLockedGifts(giftRule.locked);
        if (giftRule.unlocked) this.showUnlockedGifts(giftRule.unlocked);
        if (giftRule.messageValue) {
            const valueTexts = document.querySelectorAll(".cart-drawer-product-card__message-locked-text");
            valueTexts.forEach(text => text.innerHTML = Shopify.formatMoney(giftRule.messageValue * 100));
        }
        this.hideOtherGifts();

        return false;
    }

    hideUpsellSection() {
        this.hideSection(".cart-drawer__inner-real .cart-drawer__upsell-eggo");
    }

    hideGiftSection() {
        this.hideSection(".cart-drawer__inner-real .cart-drawer__upsell-gift");
    }

    hideBothSections() {
        this.hideSection(".cart-drawer__inner-real .cart-drawer__upsell");
    }

    hideSection(className) {
        const section = this.eggoCart.querySelector(className);
        if (!section) return;
        section.classList.add("hide-this");
    }

    generateGiftRule() {
        const noGift = {locked: null, unlocked: null, messageValue: ""};
        const giftState = {locked: null, unlocked: null, messageValue: ""};
        if (typeof cartGiftLimits === "undefined") return noGift;
        this.cartPrice = StackDiscounts.total_value;
        if (!this.cartPrice) return noGift;
        /** If the cartValue is giftLimit close to gift it will show as locked **/

        if (this.cartPrice >= cartGiftLimits[0]["low"] && this.cartPrice < cartGiftLimits[0]["high"]) {
            giftState.unlocked = 50;
        } else if (this.cartPrice >= cartGiftLimits[1]["low"] && this.cartPrice < cartGiftLimits[1]["high"]) {
            giftState.unlocked = 60;
        } else if (this.cartPrice >= cartGiftLimits[2]["low"] && this.cartPrice < cartGiftLimits[2]["high"]) {
            giftState.unlocked = 80;
        } else if (this.cartPrice >= cartGiftLimits[3]["low"] && this.cartPrice < cartGiftLimits[3]["high"]) {
            giftState.unlocked = 100;
        }

        if (this.cartPrice >= (cartGiftLimits[0]["low"] - cartGiftsRange) && this.cartPrice < cartGiftLimits[0]["low"]) {
            giftState.locked = 50;
            giftState.messageValue = cartGiftLimits[0]["low"];
        } else if (this.cartPrice >= (cartGiftLimits[1]["low"] - cartGiftsRange) && this.cartPrice < cartGiftLimits[1]["low"]) {
            giftState.locked = 60;
            giftState.messageValue = cartGiftLimits[1]["low"];
        } else if (this.cartPrice >= (cartGiftLimits[2]["low"] - cartGiftsRange) && this.cartPrice < cartGiftLimits[2]["low"]) {
            giftState.locked = 80;
            giftState.messageValue = cartGiftLimits[2]["low"];
        } else if (this.cartPrice >= (cartGiftLimits[3]["low"] - cartGiftsRange) && this.cartPrice < cartGiftLimits[3]["low"]) {
            giftState.locked = 100;
            giftState.messageValue = cartGiftLimits[3]["low"];
        }
        return giftState;
    }


    showLockedGifts(giftPrice) {
        [...this.giftDomElements].forEach((giftDomElement) => {
            if (giftDomElement.dataset.price === giftPrice.toString()) {
                giftDomElement.classList.add("lock");
                giftDomElement.classList.add("show");
            }
        });
    }

    showUnlockedGifts(giftPrice) {
        [...this.giftDomElements].forEach((giftDomElement) => {
            if (giftDomElement.dataset.price === giftPrice.toString()) {
                giftDomElement.classList.add("unlock");
                giftDomElement.classList.add("show");
            }
        });
    }

    hideOtherGifts() {
        [...this.giftDomElements].forEach((giftDomElement) => {
            if (!giftDomElement.classList.contains("show")) {
                hideDomElement(giftDomElement);
            }
        });
    }
}